/**
 * The Nepali calendar data from 1975 BS to 2099 BS.
 * Based on the array index months days (0 → 11th), total days in year (12th)
 */
const years: number[][] = [];
// fill years and their months
years[1975] = [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30, 365];
years[1976] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31, 366];
years[1977] = [30, 32, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31, 365];
years[1978] = [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30, 365];
years[1979] = years[1975];
years[1980] = years[1976];
years[1981] = [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31, 365];
years[1982] = years[1978];
years[1983] = years[1975];
years[1984] = years[1976];
years[1985] = [31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30, 365];
years[1986] = years[1978];
years[1987] = [31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30, 365];
years[1988] = years[1976];
years[1989] = [31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30, 365];
years[1990] = years[1978];
years[1991] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30, 365];
years[1992] = [31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31, 366];
years[1993] = years[1989];
years[1994] = years[1978];
years[1995] = years[1991];
years[1996] = years[1992];
years[1997] = years[1978];
years[1998] = [31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30, 365];
years[1999] = years[1976];
years[2000] = [30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31, 365];
years[2001] = years[1978];
years[2002] = years[1975];
years[2003] = years[1976];
years[2004] = years[2000];
years[2005] = years[1978];
years[2006] = years[1975];
years[2007] = years[1976];
years[2008] = years[1981];
years[2009] = years[1978];
years[2010] = years[1975];
years[2011] = years[1976];
years[2012] = years[1985];
years[2013] = years[1978];
years[2014] = years[1975];
years[2015] = years[1976];
years[2016] = years[1985];
years[2017] = years[1978];
years[2018] = years[1987];
years[2019] = years[1992];
years[2020] = years[1989];
years[2021] = years[1978];
years[2022] = years[1991];
years[2023] = years[1992];
years[2024] = years[1989];
years[2025] = years[1978];
years[2026] = years[1976];
years[2027] = years[2000];
years[2028] = years[1978];
years[2029] = years[1998];
years[2030] = years[1976];
years[2031] = years[2000];
years[2032] = years[1978];
years[2033] = years[1975];
years[2034] = years[1976];
years[2035] = years[1977];
years[2036] = years[1978];
years[2037] = years[1975];
years[2038] = years[1976];
years[2039] = years[1985];
years[2040] = years[1978];
years[2041] = years[1975];
years[2042] = years[1976];
years[2043] = years[1985];
years[2044] = years[1978];
years[2045] = years[1987];
years[2046] = years[1976];
years[2047] = years[1989];
years[2048] = years[1978];
years[2049] = years[1991];
years[2050] = years[1992];
years[2051] = years[1989];
years[2052] = years[1978];
years[2053] = years[1991];
years[2054] = years[1992];
years[2055] = years[1978];
years[2056] = years[1998];
years[2057] = years[1976];
years[2058] = years[2000];
years[2059] = years[1978];
years[2060] = years[1975];
years[2061] = years[1976];
years[2062] = [30, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31, 365];
years[2063] = years[1978];
years[2064] = years[1975];
years[2065] = years[1976];
years[2066] = years[1981];
years[2067] = years[1978];
years[2068] = years[1975];
years[2069] = years[1976];
years[2070] = years[1985];
years[2071] = years[1978];
years[2072] = years[1987];
years[2073] = years[1976];
years[2074] = years[1989];
years[2075] = years[1978];
years[2076] = years[1991];
years[2077] = years[1992];
years[2078] = years[1989];
years[2079] = years[1978];
years[2080] = years[1991];
years[2081] = years[1992];
years[2082] = years[1989];
years[2083] = years[1978];
years[2084] = years[1976];
years[2085] = years[2000];
years[2086] = years[1978];
years[2087] = years[1975];
years[2088] = years[1976];
years[2089] = years[2000];
years[2090] = years[1978];
years[2091] = years[1975];
years[2092] = years[1976];
years[2093] = years[1981];
years[2094] = years[1978];
years[2095] = years[1975];
years[2096] = years[1976];
years[2097] = years[1985];
years[2098] = years[1978];
years[2099] = years[1975];

// export years data
export { years };
